export const lang = {
	// title为每个页面的标题
	title: "商户已关闭"
}
